<template>
  <div class="assignment-item">
    <div class="assignment-item__detail">
      <i :class="gameIconClass" />
      <div class="assignment-item__info">
        <span class="assignment-item__info-text"> {{ $t("common.lesson") }} {{ order }} - {{ lesson.name }} </span>
        <span class="assignment-item__info-tag">
          <el-tag type="info" class="el-tag--small">{{ getLevel(lesson.level) }}</el-tag>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { getGameTypeIcon } from "@/utils/gameIconFactory";
import { mappingLevel } from "@/constants/elsaAI";

export default {
  props: {
    lesson: {
      type: Object,
      default: () => {},
    },
    order: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    gameIconClass() {
      return getGameTypeIcon(this.lesson.game_type);
    },
  },
  methods: {
    getLevel(str) {
      if (str in mappingLevel) {
        return mappingLevel[str][this.$i18n.locale || 'en'] || mappingLevel[str].en;
      }
      return str;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../scss/_colors.scss";
.assignment-item {
  display: flex;

  &:not(:last-child) {
    border-bottom: 1px solid $gray-2;
  }

  &__icon {
    width: 40px;
  }

  &__detail {
    display: flex;
    align-items: flex-start;
    width: 90%;
  }

  &__info {
    font-weight: normal;
    display: flex;
    flex-direction: column;
    margin-left: 20px;
    width: 90%;
  }

  &__info-tag {
    margin-top: 5px;
  }

  &__info-text {
    line-height: 24px;
  }

  &__result {
    text-align: center;
    width: 15%;
    margin-left: auto;
  }
}
</style>
